import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchIcon from '../../../CustomSVGIcons/SearchIcon';
import { FONT_ENUM } from '../../../../types/global/fonts.types';
import { Juror } from '../../../../redux/contest/types';
import { TMoreMenuItem } from '../../../More/more.data';
import { ghostBorderSx, glassCardSx } from '../../../WatchPage/watchCinemaTheme';
import { BrandContestJurorCard } from './BrandContestJurorCard';
import {
    brandJurorDesktopHeaderVisibleSx,
    brandJurorGridColumns,
    brandJurorStackedHeaderSx,
} from './brandJurorCardLayout';

const EMPTY_MESSAGE = 'No Data Available';

const HEADER_CELLS: { lines: string[] }[] = [
    { lines: ['Juror'] },
    { lines: ['Judgment', 'Progress'] },
    { lines: ['Total', 'Assigned'] },
    { lines: ['Completed'] },
    { lines: ['Invitation', 'Status'] },
    { lines: ['Actions'] },
];

const StackedHeaderLabel: React.FC<{ lines: string[]; align?: 'center' | 'start' }> = ({ lines, align = 'center' }) => (
    <Box
        sx={{
            ...brandJurorStackedHeaderSx,
            ...(align === 'start' && {
                alignItems: 'flex-start',
                textAlign: 'left',
                justifySelf: 'start',
            }),
        }}>
        {lines.map(line => (
            <Typography key={line} component="span" sx={{ fontSize: 'inherit', fontFamily: 'inherit' }}>
                {line}
            </Typography>
        ))}
    </Box>
);

export interface BrandContestJurorsListProps {
    jurors: Juror[];
    menuItems: TMoreMenuItem[];
    onMenuClick: (type: string, juror: Juror) => void;
}

const BrandContestJurorsEmptyCard: React.FC = () => (
    <Box
        sx={{
            ...glassCardSx,
            ...ghostBorderSx,
            borderRadius: 4,
            py: 8,
            px: 3,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 3,
            minHeight: 120,
        }}>
        <SearchIcon fill="#adaaaa" />
        <Typography
            sx={{
                color: '#adaaaa',
                fontSize: 18,
                fontFamily: FONT_ENUM.MAIN_REGULAR,
            }}>
            {EMPTY_MESSAGE}
        </Typography>
    </Box>
);

const BrandContestJurorsList: React.FC<BrandContestJurorsListProps> = ({ jurors, menuItems, onMenuClick }) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    ...brandJurorDesktopHeaderVisibleSx,
                    gridTemplateColumns: brandJurorGridColumns.lg,
                    columnGap: 3,
                    alignItems: 'end',
                    px: 3,
                    py: 1,
                    mb: 0.5,
                }}>
                {HEADER_CELLS.map(({ lines }, index) => (
                    <StackedHeaderLabel key={lines.join('-')} lines={lines} align={index === 0 ? 'start' : 'center'} />
                ))}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {jurors.length === 0 ? (
                    <BrandContestJurorsEmptyCard />
                ) : (
                    jurors.map(juror => (
                        <BrandContestJurorCard
                            key={juror._id}
                            juror={juror}
                            menuItems={menuItems}
                            onMenuClick={onMenuClick}
                        />
                    ))
                )}
            </Box>
        </Box>
    );
};

export { BrandContestJurorsList, EMPTY_MESSAGE as BRAND_JURORS_EMPTY_MESSAGE };
